import React from 'react';
import { motion } from 'framer-motion';
import { Users, GraduationCap, School, Building2 } from 'lucide-react';

const iconMap = {
  users: Users,
  graduationCap: GraduationCap,
  school: School,
  building: Building2
};

const ImpactSection = ({ impacts }) => {
  return (
    <section className="py-32 bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-500 rounded-full filter blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Impak Yang Akan Dicipta
          </h2>
          <p className="text-xl text-purple-200 max-w-3xl mx-auto">
            Sekolah ini bukan sekadar bangunan, tetapi pelaburan untuk masa depan generasi akan datang
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {impacts.map((impact, index) => {
            const Icon = iconMap[impact.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -10, scale: 1.02 }}
                className="group"
              >
                <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 hover:border-purple-300/50 transition-all duration-300 h-full hover:shadow-2xl hover:shadow-purple-500/20">
                  <motion.div
                    whileHover={{ rotate: 360, scale: 1.1 }}
                    transition={{ duration: 0.6 }}
                    className="mb-6"
                  >
                    <div className="w-16 h-16 bg-gradient-to-br from-purple-400 to-pink-400 rounded-2xl flex items-center justify-center group-hover:shadow-lg group-hover:shadow-purple-400/50 transition-shadow duration-300">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                  </motion.div>
                  <div className="text-5xl font-bold text-white mb-3">
                    {impact.number}
                  </div>
                  <div className="text-purple-200 text-lg">
                    {impact.label}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;